import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../services/http-client.service";
import { LanguageService } from "../../services/language.service";
let BankaccountWhitelistInfoExchangeComponent = class BankaccountWhitelistInfoExchangeComponent {
    constructor(sanitizer, themeService, location, httpClient, languageService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.location = location;
        this.httpClient = httpClient;
        this.languageService = languageService;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.successColor = '';
        this.buttonClicked = false;
        this.url = '';
        this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        this.textColor = this.themeService.getStyleAttribute('text_color');
        this.successColor = this.themeService.getStyleAttribute('success_color');
        location.onPopState(() => {
            this.close();
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
        this.url = window.location.href;
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    goToBlinking() {
        this.buttonClicked = true;
        this.httpClient.post('blinking/initiateBankAccountProcess', { languageCode: this.lang, redirectUrl: this.url }).subscribe((data) => {
            this.close();
            window.open(data['url'], '_self');
        }, (error) => {
            this.buttonClicked = false;
        });
    }
};
BankaccountWhitelistInfoExchangeComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: LocationStrategy },
    { type: SharedHttp },
    { type: LanguageService }
];
BankaccountWhitelistInfoExchangeComponent = __decorate([
    Component({
        selector: 'app-bankaccount-whitelist-info-exchange',
        template: __importDefault(require("./bankaccount-whitelist-info-exchange.component.html")).default,
    })
], BankaccountWhitelistInfoExchangeComponent);
export { BankaccountWhitelistInfoExchangeComponent };
